import { render, staticRenderFns } from "./emailElementViewer.vue?vue&type=template&id=6f071f1a&scoped=true&"
import script from "./emailElementViewer.vue?vue&type=script&lang=js&"
export * from "./emailElementViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f071f1a",
  null
  
)

export default component.exports